import { storageToken } from 'constants/wallet'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

const sendRequest = async (
  payload: AxiosRequestConfig,
  doesReturnHeader = false
): Promise<AxiosResponse<any, any> | any> => {
  try {
    payload.headers = payload.headers
      ? payload.headers
      : { Authorization: 'Bearer ' + accessToken() }

    if (doesReturnHeader) {
      const rest = await axiosInstance.request(payload)
      return rest
    }

    const response = await axiosInstance.request(payload)

    return Promise.resolve(response?.data)
  } catch (error: any) {
    return Promise.reject(error)
  }
}

export const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (err: AxiosError) => {
    const { response } = err

    try {
      return response
    } catch (error) {
      return response
    }
  }
)

export function accessToken() {
  const token = localStorage.getItem(storageToken)
  return token === null ? undefined : token
}

export function setAccessToken(value?: string) {
  if (value) {
    localStorage.setItem(storageToken, value)
  } else {
    localStorage.removeItem(storageToken)
  }

  return value
}

export default sendRequest
